import { saveAs } from "file-saver";
import { ENUM_CURRENCY } from "../../../enums";
import { convertToFullName, numberFormat } from "../../../services/utils";

function escapeCsvValue(value) {
  if (value == null) return "";
  const str = String(value);
  if (str.includes(",") || str.includes('"') || str.includes("\n")) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

function convertToCsv(headers: string[], rows: string[][]) {
  const lines = [
    headers.map(escapeCsvValue).join(","),
    ...rows.map((row) => row.map(escapeCsvValue).join(",")),
  ];
  return lines.join("\n");
}

const AMBASSADOR_EXPORT_HEADERS = [
  "Name",
  "Email",
  "Title",
  "Company",
  "Est. Employees",
  "Industry",
  "Rate",
];

function mapAmbassadorToExportRow(ambassador) {
  return [
    convertToFullName(ambassador.firstName, ambassador.lastName),
    ambassador.email || "",
    ambassador.title || "",
    ambassador.company || "",
    ambassador.no_of_emp || "",
    ambassador.industry || "",
    numberFormat(ambassador.round_table_package_12_rate, ENUM_CURRENCY.USD) ||
      "",
  ];
}

function downloadAmbassadorListCsv(ambassadors: any[] = []) {
  const csvContent = convertToCsv(
    AMBASSADOR_EXPORT_HEADERS,
    ambassadors.map(mapAmbassadorToExportRow)
  );
  const blob = new Blob(["\uFEFF" + csvContent], {
    type: "text/csv;charset=utf-8;",
  });
  const date = new Date().toISOString().slice(0, 10);
  saveAs(blob, `ambassadors-${date}.csv`);
}

export { downloadAmbassadorListCsv };
